(() => {
  const collectionLinkElems = document.querySelectorAll('a[href*="/collections/"]:not([href$="/collections/archive"])');

  collectionLinkElems.forEach(linkElem => {
    const url = new URL(linkElem.href);
    url.searchParams.append('filter.v.availability', 1);
    linkElem.href = url.toString();
  });
})();
